<template>
  <div class="etarget">
    <div id="secNavBox">
      <secondnav :nav="'erange'" @changetable="changeTab"></secondnav>
    </div>
    <div id="secNavNextBox"></div>
    <div class="mainWidth">
      <div class="main_box">
        <mu-row gutter class="main_tags">
          <mu-row gutter  class="tags_img_box">
            <mu-col width="50" tablet="50" desktop="50">
              <div class="tags_img">
                <img :src="$t('erange.tabs['+activeTab+'].foundImg')">
              </div>
            </mu-col>
            <mu-col class="tags_detail_box" width="50" tablet="50" desktop="50">
              <div class="tags_title_box">
                <div class="tags_intro_title">{{$t('erange.tabs['+activeTab+'].title')}}</div>
                <div class="tags_intro_subTitle">{{$t('erange.tabs['+activeTab+'].subTitle')}}</div>
              </div>

              <div class="tags_detail" v-for="item in $t('erange.tabs['+activeTab+'].intro')">
                <span>{{item}}</span>
              </div>
              <!--<div class="tags">-->
              <!--<span class="tags_icon"><img src="../../static/lip.png"></span><span class="tags_item" v-for="item in $t('erange.tabs['+activeTab+'].tags')" :key="item">{{item}}</span>-->
              <!--</div>-->
              <mu-row gutter class="main_merits">
                <mu-col class="" width="100" tablet="100" desktop="100"  v-for="item in $t('erange.tabs['+activeTab+'].merits')" :key="item">
                  <div class="merits">
                    <span class="merits_icon"></span><span class="merits_item">{{item}}</span>
                  </div>
                </mu-col>

              </mu-row>
            </mu-col>
          </mu-row>

        </mu-row>
      </div>

    </div>


  </div>
</template>

<script>
  import secondnav from '../components/secondnav'
  export default {
    name: 'etarget',
    metaInfo: {
      title: '枪弹柜_枪弹库_智能枪弹柜_速得尔科技（北京）有限公司', // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: '枪弹柜，枪弹库，智能靶场，速得尔智能靶场系统，速得尔智能枪弹柜'
      }, {                 // set meta
        name: 'description',
        content: '速得尔智能枪弹柜系统采用多重身份识别系统，安全可靠，入库出库效率高，信息可追溯，无缝接入公安监控系统'
      }]
    },
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){
      this.$route.query.idx?this.changeTab(this.$route.query.idx):'';
    },
    components:{
      secondnav,
    },
    methods:{
      changeTab(idx){  //tab切换
        window.scrollTo(0,0);
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .etarget{
    overflow:hidden;
    background-color:#E6E6E6;
    .tab{
      background:#fff!important;
      margin:17px auto;
      .tab_box{
        margin-left:60px;
        .tab_item{
          display:inline-block;
          width:30%;
          min-width:220px;
          >span{
            display:inline-block;
            height:34px;
            line-height:34px;
            font-size: 14px;
            color: #9196AC;
            letter-spacing: 0;
            padding:0px 12px;
            cursor:pointer;
            font-weight:600;
            transition:all 500ms;
            &:hover{
              color: #20A9F2;
            }
            &.active{
              background: #20A9F2;
              border-radius: 3px;
              color:#FFF;

            }
          }

        }
      }
      .dianziba_icon_box{
        overflow:hidden;
        .dianziba_icon{
          width:194px;
          float:right;
          >img{
            width:inherit;
            height:inherit;
          }
        }
      }

    }
    .main_box{
      background:#fff;
      overflow:hidden;
      margin-top:17px;
      margin-bottom:60px;
      padding-bottom:60px;
      .main_tags{
        .tags_img_box{
          width:100%;
          height:auto;
          background: #FBFBFB;
          margin:150px 50px 40px 50px;
          .tags_img{
            width:450px;
            height:450px;
            position:relative;
            padding:38px;
            >img{
              height:inherit;
              widht:inherit;
              position:absolute;
              top:-80px;
            }
          }
          .tags_detail_box{
            position:relative;
            .tags_title_box{
              position:absolute;
              top:-80px;
              .tags_intro_title{
                height:40px;
                line-height:40px;
                font-size: 24px;
                color: #3B3B3B;
                letter-spacing: 0;
                font-weight:600;
                text-align:left;
                vertical-align:middle;
                /*&:before{*/
                /*content:'';*/
                /*background:url("../../static/shengxue.png") no-repeat center center;*/
                /*background-size:100% 100%;*/
                /*vertical-align:middle;*/
                /*width:46px;*/
                /*height:40px;*/
                /*margin-right:18px;*/
                /*display:inline-block;*/
                /*}*/
              }
              .tags_intro_subTitle{
                height:30px;
                line-height:30px;
                font-size: 18px;
                color: #9196AC;
                font-weight:600;
                letter-spacing: 0;
                text-align:left;
                vertical-align:middle;
              }

            }
            .tags_detail{
              margin:20px 30px 20px 0px;
              font-size: 16px;
              color:#333;
              letter-spacing:0;
              line-height: 27px;
              /*font-weight:600;*/
              text-align: justify;
            }
            .tags{
              span{
                font-size: 14px;
                color: #20A9F2;
                letter-spacing: 0;
                line-height: 22px;
                padding:0px 8px;
                font-weight:600;
              }
              .tags_icon{
                width:16px;
                height:13px;
                display:inline-block;
                margin-right:8px;
                img{
                  width:inherit;
                  height:inherit;
                }
              }
            }


          }

        }

      }
      .main_merits{
        .merits{
          .merits_icon{
            display: inline-block;
            width:13px;
            height:13px;
            background: url("../../static/star-1.png") no-repeat center center;
            background-size: 100% 100%;
            margin-right:8px;
            vertical-align: middle;
          }
          .merits_item{
            display:inline-block;
            font-size: 14px;
            color:#333;
            /*font-weight: 600;*/
            letter-spacing: 0;
            line-height: 28px;
            vertical-align: middle;
          }
        }
      }
      .main_imgs{
        margin:0px 102px;
        border-top:1px solid #E8E8E8;
        .imgs_box{
          width:80%;
          margin:0 auto;
          >img{
            width:100%;
            height:auto;
            margin:60px 0px;
            text-align:center;
            display:inline-block;
          }
          .description{
            font-size: 24px;
            line-height:30px;
            color:#3B3B3B;
            letter-spacing: 0;
            width:75%;
            margin:0 auto;
            text-align:center;
          }
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/erange.vue